import { render, staticRenderFns } from "./PropertySpecificSymptoms.vue?vue&type=template&id=232499a9&scoped=true"
import script from "./PropertySpecificSymptoms.vue?vue&type=script&lang=js"
export * from "./PropertySpecificSymptoms.vue?vue&type=script&lang=js"
import style0 from "./PropertySpecificSymptoms.vue?vue&type=style&index=0&id=232499a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232499a9",
  null
  
)

export default component.exports